import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllPortalSettings, setAllNewPortalSettingValues } from '../actions/portalSetting';
import PortalSettingsLisingPage from '../components/pages/portal-settings/view-all/content';
import NotFoundPage from './NotFoundPage.js';

function PortalSettingsPage() {
  const redirectToPageNotFound = useSelector((state) => state.sharedReducer.redirectToPageNotFound);
  const hasAdminRights = useSelector((state) => state.usersReducer.userProfile.hasAdminRights);

  useEffect(() => {
    dispatch(getAllPortalSettings());

    return () => {
      getAllPortalSettings(null);
    };
  }, []);

  const dispatch = useDispatch();

  if (!redirectToPageNotFound && hasAdminRights) {
    return <PortalSettingsLisingPage />;
  } else if (redirectToPageNotFound || hasAdminRights === false) {
    return <NotFoundPage dispatch={dispatch} />;
  } else {
    // We need to use this, otherwise the NotFoundPage will flash before showing the report tiles
    return '';
  }
}

export default PortalSettingsPage;
